export const products = [
  { value: 'headway', text: 'Headway' },
  { value: 'nova', text: 'Nova' },
  { value: 'FindGuide', text: 'FindGuide' },
]
